import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "containter topBar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "ps-10 pt-5 mb-0" }, "Rango de fechas", -1)
const _hoisted_3 = { class: "dateRange mb-4" }
const _hoisted_4 = { class: "containter-fluid" }
const _hoisted_5 = { class: "row mt-5" }
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 bgFondo borderRadius" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_9 = { class: "row mt-5 mb-5" }
const _hoisted_10 = { class: "col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end" }
const _hoisted_11 = { class: "spanStyle bgBlue" }
const _hoisted_12 = { class: "col-xs-6 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_13 = { class: "ulStyle" }
const _hoisted_14 = { class: "fw500" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Vehículos vendidos")
], -1)
const _hoisted_16 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_17 = { class: "row mt-5 mb-5" }
const _hoisted_18 = { class: "col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end" }
const _hoisted_19 = { class: "spanStyle bgGreen" }
const _hoisted_20 = { class: "col-xs-6 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_21 = { class: "ulStyle" }
const _hoisted_22 = { class: "fw500" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Citas agendadas")
], -1)
const _hoisted_24 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_25 = { class: "row mt-5 mb-5" }
const _hoisted_26 = { class: "col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-end" }
const _hoisted_27 = { class: "spanStyle bgRed" }
const _hoisted_28 = { class: "col-xs-6 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_29 = { class: "ulStyle" }
const _hoisted_30 = { class: "fw500" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Avalúos realizados")
], -1)
const _hoisted_32 = { class: "row mt-8" }
const _hoisted_33 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 leftCol" }
const _hoisted_34 = { class: "buscados borderRadius" }
const _hoisted_35 = { class: "row mb13" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Vehículos más buscados")
], -1)
const _hoisted_37 = { class: "ulStyle" }
const _hoisted_38 = { class: "mt-2 mb-4" }
const _hoisted_39 = { class: "fw500" }
const _hoisted_40 = { class: "fs16 fw400" }
const _hoisted_41 = { class: "fs15" }
const _hoisted_42 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 leftRight" }
const _hoisted_43 = { class: "buscados borderRadius" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Marcas más buscadas")
], -1)
const _hoisted_46 = { class: "ulStyle" }
const _hoisted_47 = { class: "mt-2 mb-4 flowRoot" }
const _hoisted_48 = { class: "fw500 float-end fs16" }
const _hoisted_49 = { class: "fs16 fw400" }
const _hoisted_50 = { class: "fs15" }
const _hoisted_51 = { class: "row mt-8" }
const _hoisted_52 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 leftCol" }
const _hoisted_53 = { class: "buscados pb-0 borderRadius" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Citas de avalúos a domicilio")
], -1)
const _hoisted_56 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr" }
const _hoisted_57 = { class: "ulStyle" }
const _hoisted_58 = { class: "mt-2 mb-2" }
const _hoisted_59 = { class: "fw500 fs30" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400" }, "Total de citas")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_62 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr" }
const _hoisted_63 = { class: "ulStyle" }
const _hoisted_64 = { class: "mt-2 mb-2" }
const _hoisted_65 = { class: "fw500 fs30" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Pendientes")
], -1)
const _hoisted_67 = { class: "fs13" }
const _hoisted_68 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct" }
const _hoisted_69 = { class: "ulStyle" }
const _hoisted_70 = { class: "mt-2 mb-2" }
const _hoisted_71 = { class: "fw500 fs30" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Canceladas")
], -1)
const _hoisted_73 = { class: "fs13" }
const _hoisted_74 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr" }
const _hoisted_75 = { class: "ulStyle" }
const _hoisted_76 = { class: "mt-2 mb-2" }
const _hoisted_77 = { class: "fw500 fs30" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Atendidas")
], -1)
const _hoisted_79 = { class: "fs13" }
const _hoisted_80 = { class: "col-xs-12 col-sm-12 col-md-8 col-lg-8 bct" }
const _hoisted_81 = { class: "ulStyle" }
const _hoisted_82 = { class: "mt-2 mb-2" }
const _hoisted_83 = { class: "fw500 fs30" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Efectivas")
], -1)
const _hoisted_85 = { class: "fs13" }
const _hoisted_86 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 leftRight" }
const _hoisted_87 = { class: "buscados pb-0 borderRadius" }
const _hoisted_88 = { class: "row" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16" }, "Avalúos a domicilio")
], -1)
const _hoisted_90 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-6 bct bcr" }
const _hoisted_91 = { class: "ulStyle" }
const _hoisted_92 = { class: "mt-2 mb-2" }
const _hoisted_93 = { class: "fw500 fs30" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600" }, "Totales")
], -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_96 = { class: "col-xs-12 col-sm-12 col-md-6 col-lg-6 bct" }
const _hoisted_97 = { class: "ulStyle" }
const _hoisted_98 = { class: "mt-2 mb-2" }
const _hoisted_99 = { class: "fw500 fs30" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Comprados")
], -1)
const _hoisted_101 = { class: "fs13" }
const _hoisted_102 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr" }
const _hoisted_103 = { class: "ulStyle" }
const _hoisted_104 = { class: "mt-2 mb-2" }
const _hoisted_105 = { class: "fw500 fs30" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "Cancelados")
], -1)
const _hoisted_107 = { class: "fs13" }
const _hoisted_108 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct bcr" }
const _hoisted_109 = { class: "ulStyle" }
const _hoisted_110 = { class: "mt-2 mb-2" }
const _hoisted_111 = { class: "fw500 fs30" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "En documentación")
], -1)
const _hoisted_113 = { class: "fs13" }
const _hoisted_114 = { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 bct" }
const _hoisted_115 = { class: "ulStyle" }
const _hoisted_116 = { class: "mt-2 mb-2" }
const _hoisted_117 = { class: "fw500 fs30" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw400 mb-0" }, "En negociación")
], -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_120 = {
  key: 0,
  class: "row mt-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Agencies = _resolveComponent("Agencies")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DateRange, {
          onGetDates: _ctx.getDates,
          range: true,
          placeholder: _ctx.placesHolderDates,
          class: _normalizeClass(["ps-10", 'dashboard']),
          selectText: 'Aplicar',
          cancelText: 'Cancelar'
        }, null, 8, ["onGetDates", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, {
                      height: "40",
                      width: "40",
                      src: "media/icons/iconsax/car.svg"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("ul", _hoisted_13, [
                    _createElementVNode("li", null, [
                      _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.dashboardDataAdmin.vehiculos_vendidos), 1)
                    ]),
                    _hoisted_15,
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'vehicles-filters', params: {filter:4} },
                        class: "routerUnder"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ver vehículos ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, {
                      height: "40",
                      width: "40",
                      src: "media/icons/iconsax/calendar.svg"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("ul", _hoisted_21, [
                    _createElementVNode("li", null, [
                      _createElementVNode("h1", _hoisted_22, _toDisplayString(_ctx.dashboardDataAdmin.citas_agendadas_en_sitio), 1)
                    ]),
                    _hoisted_23,
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/citas",
                        class: "routerUnder"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ver citas de agencias ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_inline_svg, {
                      height: "40",
                      width: "40",
                      src: "media/icons/iconsax/receipt-item.svg"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("ul", _hoisted_29, [
                    _createElementVNode("li", null, [
                      _createElementVNode("h1", _hoisted_30, _toDisplayString(_ctx.dashboardDataAdmin.avaluos_en_agencia), 1)
                    ]),
                    _hoisted_31,
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/avaluos",
                        class: "routerUnder"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ver avalúos de agencias ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardDataAdmin.modelos_populares, (modelo) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-xs-12 col-sm-12 col-md-4 col-lg-4",
                  key: modelo.marca
                }, [
                  _createElementVNode("ul", _hoisted_37, [
                    _createElementVNode("li", _hoisted_38, [
                      _createElementVNode("h1", _hoisted_39, "#" + _toDisplayString(modelo.rating), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("p", _hoisted_40, _toDisplayString(modelo.marca), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("p", _hoisted_41, _toDisplayString(modelo.total) + " búsquedas", 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardDataAdmin.marcas_populares, (marca) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 pe-10",
                  key: marca.marca
                }, [
                  _createElementVNode("ul", _hoisted_46, [
                    _createElementVNode("li", _hoisted_47, [
                      _createVNode(_component_inline_svg, {
                        src: "{{ marca.icon }}",
                        height: "40",
                        width: "40",
                        class: "float-start"
                      }),
                      _createElementVNode("p", _hoisted_48, "#" + _toDisplayString(marca.rating), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("p", _hoisted_49, _toDisplayString(marca.marca), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("p", _hoisted_50, _toDisplayString(marca.total) + " búsquedas", 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("ul", _hoisted_57, [
                  _createElementVNode("li", _hoisted_58, [
                    _createElementVNode("h1", _hoisted_59, _toDisplayString(_ctx.dashboardDataAdmin.citas_avaluo_domicilio.total), 1)
                  ]),
                  _hoisted_60,
                  _hoisted_61
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("ul", _hoisted_63, [
                  _createElementVNode("li", _hoisted_64, [
                    _createElementVNode("h1", _hoisted_65, _toDisplayString(_ctx.dashboardDataAdmin.citas_avaluo_domicilio.pendientes), 1)
                  ]),
                  _hoisted_66,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_67, [
                      _createVNode(_component_router_link, {
                        to: "/calendario",
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("ul", _hoisted_69, [
                  _createElementVNode("li", _hoisted_70, [
                    _createElementVNode("h1", _hoisted_71, _toDisplayString(_ctx.dashboardDataAdmin.citas_avaluo_domicilio.canceladas), 1)
                  ]),
                  _hoisted_72,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_73, [
                      _createVNode(_component_router_link, {
                        to: "/calendario",
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("ul", _hoisted_75, [
                  _createElementVNode("li", _hoisted_76, [
                    _createElementVNode("h1", _hoisted_77, _toDisplayString(_ctx.dashboardDataAdmin.citas_avaluo_domicilio.atendida), 1)
                  ]),
                  _hoisted_78,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_79, [
                      _createVNode(_component_router_link, {
                        to: "/calendario",
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("ul", _hoisted_81, [
                  _createElementVNode("li", _hoisted_82, [
                    _createElementVNode("h1", _hoisted_83, _toDisplayString(_ctx.dashboardDataAdmin.citas_avaluo_domicilio.efectivas), 1)
                  ]),
                  _hoisted_84,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_85, [
                      _createVNode(_component_router_link, {
                        to: "/calendario",
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("ul", _hoisted_91, [
                  _createElementVNode("li", _hoisted_92, [
                    _createElementVNode("h1", _hoisted_93, _toDisplayString(_ctx.dashboardDataAdmin.avaluo_domicilio.total), 1)
                  ]),
                  _hoisted_94,
                  _hoisted_95
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("ul", _hoisted_97, [
                  _createElementVNode("li", _hoisted_98, [
                    _createElementVNode("h1", _hoisted_99, _toDisplayString(_ctx.dashboardDataAdmin.avaluo_domicilio.comprados), 1)
                  ]),
                  _hoisted_100,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_101, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:3} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("ul", _hoisted_103, [
                  _createElementVNode("li", _hoisted_104, [
                    _createElementVNode("h1", _hoisted_105, _toDisplayString(_ctx.dashboardDataAdmin.avaluo_domicilio.cancelado), 1)
                  ]),
                  _hoisted_106,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_107, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:4} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("ul", _hoisted_109, [
                  _createElementVNode("li", _hoisted_110, [
                    _createElementVNode("h1", _hoisted_111, _toDisplayString(_ctx.dashboardDataAdmin.avaluo_domicilio.en_documentacion), 1)
                  ]),
                  _hoisted_112,
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_113, [
                      _createVNode(_component_router_link, {
                        to: { name: 'appraisals-filters', params: {filter:2} },
                        class: "subrayado"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Detalles")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("ul", _hoisted_115, [
                  _createElementVNode("li", _hoisted_116, [
                    _createElementVNode("h1", _hoisted_117, _toDisplayString(_ctx.dashboardDataAdmin.avaluo_domicilio.en_negociacion), 1)
                  ]),
                  _hoisted_118,
                  _hoisted_119
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.tipoRol != 'Múltiples agencias' && _ctx.tipoRol != 'Ciudad')
        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
            _createVNode(_component_Agencies, { dashboard: false })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}